<template>
  <div class="closeButton">
    <iconfont
      name="#icon20-12guanbianniujiaohu"
      font-size="12px"
    ></iconfont>
  </div>
</template>

<script>
export default {
  name: 'CloseButton',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.closeButton {
  width: 12px;
  height: 12px;
  cursor: pointer;
  color: #666666;
  &:hover {
    color: #9e9e9e;
  }
}
</style>
